export default __webpack_public_path__ + "static/media/gradle.a2c06628.jpg";